import Api from './api'

export default {
  register (credentials) {
    return Api().post('auth/register', credentials)
  },
  login (credentials, config) {
    return Api().post('auth/login', credentials, config)
  },
  forgottenpassword (credentials) {
    return Api().post('auth/forgottenpassword', credentials)
  },
  resetpassword (credentials) {
    return Api().post('auth/resetpassword', credentials)
  } 
}
